export default class RegExpUtil {
  static isValidRegExp = (regex) => {
    try {
      const regexp = new RegExp(regex);
      return Object.prototype.toString.call(regexp) === '[object RegExp]';
    } catch (e) {
      return false;
    }
  };

  static isRegExpLike = (text) => {
    if (!text) return false;
    return ['*', '?', '+', '{', '}', '(', ')', '|', '^', '$', '.', '[', ']', '\\'].some(char => text.includes(char));
  };

  // @see https://github.com/facebook/react/issues/3386#issuecomment-78605760
  static replacePatternToComponent = (text, pattern, callback) => {
    if (!text) {
      return;
    }

    let splitText = text.split(pattern);
    for (var i = 1; i < splitText.length; i += 2) {
      splitText[i] = callback(splitText[i]);
    }
    return splitText;
  };

  static replacePattern = (text, pattern, callback) => this.replacePatternToComponent(text, pattern, callback).join('');
}
